import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Your web app's Firebase configuration
// REPLACE THESE VALUES with your actual Firebase config from Firebase Console
// Get these from: Firebase Console → Project Settings → Your apps → Config
const firebaseConfig = {
  apiKey: "AIzaSyD_hO4AszgATdk4hYmPuBpiJbmAm2z2EjI",
  authDomain: "jewish-life-platform.firebaseapp.com",
  projectId: "jewish-life-platform",
  storageBucket: "jewish-life-platform.firebasestorage.app",
  messagingSenderId: "998821185112",
  appId: "1:998821185112:web:233dc23d7e3c562ef6ac2d",
  measurementId: "G-FBR1RNLHLH"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
// Initialize functions - use default region for production
// For v2 functions, region is specified in the function definition
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// Connect to emulators ONLY if explicitly enabled via environment variable
// This prevents auto-connecting when emulators aren't running
// To use emulators, set REACT_APP_USE_EMULATORS=true in your .env file
const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';

if (useEmulators) {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectStorageEmulator(storage, 'localhost', 9199);
    console.log('🔥 Connected to Firebase emulators');
  } catch (error) {
    // Emulators already connected, ignore error
    if (!error.message.includes('already been called')) {
      console.warn('Could not connect to emulators:', error);
    }
  }
} else {
  console.log('Using production Firebase services. To use emulators, set REACT_APP_USE_EMULATORS=true in .env');
}

export default app;
